import React from 'react';
import { Link } from 'react-router-dom';
import { navigationLinks, contactData } from '../data/mock';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1E3A5F] text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <img
              src="/images/csed-logo.png"
              alt="CSED Logo"
              className="h-16 w-auto mb-4"
            />
            <p className="text-sm text-gray-300 leading-relaxed">
              Strengthening India's development architecture through integrated,
              systems-level interventions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#E87722]">
              Quick Links
            </h3>
            <nav className="flex flex-col space-y-2">
              {navigationLinks.slice(0, 4).map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-gray-300 hover:text-[#E87722] transition-colors duration-200"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* More Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#E87722]">
              Explore
            </h3>
            <nav className="flex flex-col space-y-2">
              {navigationLinks.slice(4).map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-gray-300 hover:text-[#E87722] transition-colors duration-200"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#E87722]">
              Contact Us
            </h3>
            <div className="flex flex-col space-y-3">
              <a
                href={`mailto:${contactData.email}`}
                className="flex items-center space-x-2 text-sm text-gray-300 hover:text-[#E87722] transition-colors duration-200"
              >
                <Mail size={16} />
                <span>{contactData.email}</span>
              </a>
              <a
                href={`tel:${contactData.phone}`}
                className="flex items-center space-x-2 text-sm text-gray-300 hover:text-[#E87722] transition-colors duration-200"
              >
                <Phone size={16} />
                <span>{contactData.phone}</span>
              </a>
              <div className="flex items-start space-x-2 text-sm text-gray-300">
                <MapPin size={16} className="mt-1 flex-shrink-0" />
                <span>{contactData.address}</span>
              </div>
            </div>

            {/* Social Links */}
            <div className="flex space-x-4 mt-4">
              <a
                href="#"
                className="text-gray-300 hover:text-[#E87722] transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="#"
                className="text-gray-300 hover:text-[#E87722] transition-colors duration-200"
                aria-label="Twitter"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Chamber for Socio Economic Development. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link
              to="/privacy"
              className="text-sm text-gray-400 hover:text-[#E87722] transition-colors duration-200"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              className="text-sm text-gray-400 hover:text-[#E87722] transition-colors duration-200"
            >
              Terms of Service
            </Link>
            <Link
              to="/governance"
              className="text-sm text-gray-400 hover:text-[#E87722] transition-colors duration-200"
            >
              Governance
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
